import { imagePath } from "../../../../utils/imagePath";

export const caseStudies = [
  {
    id: 1,
    title: 'Americana',
    subtitle: 'AR Recipe Discovery Experience',
    image: imagePath?.Americana,
    tags: ['AR', 'Retail & E-Commerce'],
    industry: 'Retail & E-Commerce',
    technology: 'AR',
    data: 'Customer Data',
    route: '/all-industries/americana',
  },
  {
    id: 2,
    title: 'Raghava Life Sciences',
    subtitle: 'VR Pharma SOP Safety Training',
    image: imagePath?.RaghvaLife,
    tags: ['VR', 'Healthcare & Pharma'],
    industry: 'Healthcare & Pharma',
    technology: 'IoT',
    data: 'Analytics',
    route: '/all-industries/raghva-life-sciences',
  },
  {
    id: 3,
    title: 'Immersive Anatomy',
    subtitle: 'AR/MR Medical Learning an Research',
    image: imagePath?.immersiveAnatomy,
    tags: ['AR/MR', 'Education & Training'],
    industry: 'Education & Training',
    technology: 'AR',
    data: 'Learning Data',
    route: '/all-industries/corpus-codex',
  },
  {
    id: 4,
    title: 'Medha Servo Drives',
    subtitle: 'Loco Pilot Simulator Training',
    image: imagePath?.MedhaServo,
    tags: ['MR', 'Automotive & Transportation'],
    industry: 'Automotive & Transportation',
    technology: 'IoT',
    data: 'Operations',
    route: '/all-industries/medha-servo-drives',
  },
  {
    id: 5,
    title: 'Raghava Projects',
    subtitle: ' AR Property Visualization for ads',
    image: imagePath?.Raghava,
    tags: ['AR', 'Architecture & Real-Estate'],
    industry: 'Architecture & Real-Estate',
    technology: 'AR',
    data: 'Project Data',
    route: '/all-industries/raghva-projects',
  },
  {
    id: 6,
    title: 'RST Trading',
    subtitle: 'QR-Based WebAR Marketing',
    image: imagePath?.RST,
    tags: ['AR', 'Retail & E-Commerce'],
    industry: 'Retail & E-Commerce',
    technology: 'Blockchain',
    data: 'Financial Data',
    route: '/all-industries/rst-trading',
  },
  {
    id: 7,
    title: 'Singareni Collieries',
    subtitle: 'Mining Safety VR Training',
    image: imagePath?.Singareni,
    tags: ['VR', 'Energy and Mining'],
    industry: 'Energy & Mining',
    technology: 'IoT',
    data: 'Operations',
    route: '/all-industries/singareni-collieries',
  },
  {
    id: 8,
    title: 'Creme 21',
    subtitle: 'AI-Led AR Product Showcase',
    image: imagePath?.Cremeweb21,
    tags: ['AR', 'Retail & E-Commerce'],
    industry: 'Retail & E-Commerce',
    technology: 'Projection',
    data: 'Customer Data',
    route: '/all-industries/creme21',
  },
  {
    id: 9,
    title: 'Karnataka Tourism',
    subtitle: 'Virtual Heritage & Destination Showcase',
    image: imagePath?.KarnatakaTourism,
    tags: ['AR/MR', 'Tourism and Hospitality'],
    industry: 'Tourism & Hospitality',
    technology: 'AR',
    data: 'Visitor Data',
    route: '/all-industries/karnataka-tourism',
  },
  // {
  //   id: 10,
  //   title: 'Nestle S26',
  //   subtitle: 'AR Infant Nutrition Engagement',
  //   image: imagePath?.Nestle,
  //   tags: ['AR', 'Retail & E-Commerce'],
  //   industry: 'Retail & E-Commerce',
  //   technology: 'Projection',
  //   data: 'City Data',
  //   route: '/all-industries/nestles26',
  // },
  {
    id: 11,
    title: 'Car Mechanic Training',
    subtitle: 'Hands-On Mechanic Training',
    image: imagePath?.VrTraining,
    tags: ['VR', 'Manufacturing & Industrial'],
    industry: 'Manufacturing & Industrial',
    technology: 'IoT',
    data: 'Farm Data',
    route: '/all-industries/car-mechanic-training',
  },
  {
    id: 12,
    title: 'Defence- Missile Trajectory',
    subtitle: 'Real-Time Defense Simulation',
    image: imagePath?.MissileSimulation,
    tags: ['Simulation', 'Defence and Space'],
    industry: 'Defence & Aerospace',
    technology: 'Blockchain',
    data: 'Financial Data',
    // route: '/all-industries/defence',
    isRestricted: true,
  },

  {
    id: 13,
    title: 'Space-4D Experiences',
    subtitle: 'Multi-Sensory Space Exploration',
    image: imagePath?.FourdImmersive,
    tags: ['Simulation', 'Defence and Space'],
    industry: 'Defence & Aerospace',
    technology: 'Blockchain',
    data: 'Financial Data',
    route: '/all-industries/space-4dimmersive-experience',
  },
  {
    id: 14,
    title: 'Space- Disaster Management',
    subtitle: 'Immersive Disaster Response Visualization',
    image: imagePath?.GeospatialManagement,
    tags: ['Simulation', 'Defence and Space'],
    industry: 'FinanceDefence & Aerospace',
    technology: 'Blockchain',
    data: 'Financial Data',
    route: '/all-industries/geo-spatial',
  },
];
